// ng build --env=sorpro --bh /oficina/
// npm run build:sorpro
export const environment = {
  production: true,
  urlApi: 'https://aguadesoria.com/webapi/api/',
  site: 'SEMAS',
  logo: 'logo2s.png',
  pie: 'Agua de Soria',
  faqs: 'soria',
  capchasiteKey: '6Ld801IUAAAAAOTvnkTeD_SQ--klB_VcZ8y2pTdo',
  version: '0.5',
  ganalytics: 'UA-11568983-41'
};



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/environments/environment.ts